import React from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';
import styled from 'styled-components';

import IconButton from '../../../components/IconButton';

import { BillingEstateItem } from '../types';

type Props = {
  estate: BillingEstateItem;
  onViewDetails: (estate: BillingEstateItem) => void;
  onShareBiometry: (estate: BillingEstateItem) => void;
  onManageRegistration: (estate: BillingEstateItem) => void;
  onRetryBiometry?: (estate: BillingEstateItem) => void;
  onViewCharges: (estate: BillingEstateItem) => void;
  onEditBankAccount?: (estate: BillingEstateItem) => void;
};

const ActionsDropdownMenu = styled(Dropdown.Menu)`
  &&& {
    min-width: 210px;
    width: 210px;
    z-index: 9999;
  }
`;

const EstatesChargesActionsMenu: React.FC<Props> = ({
  estate,
  onViewDetails,
  onShareBiometry,
  onManageRegistration,
  onRetryBiometry,
  onViewCharges,
  onEditBankAccount
}) => {
  const showBiometryAction = estate.status === 'BIOMETRY_PENDING';
  const showRetryBiometryAction =
    estate.status === 'BIOMETRY_REJECTED' && Boolean(onRetryBiometry);
  const showRegistrationAction =
    estate.status === 'REGISTRATION_PENDING' ||
    estate.status === 'REGISTRATION_INCOMPLETE';
  const showViewChargesAction = estate.status === 'ACTIVE';
  const showEditBankAccountAction =
    estate.status === 'ACTIVE' && Boolean(onEditBankAccount);

  return (
    <Menu compact>
      <Menu.Item>
        <Dropdown trigger={<IconButton name="ellipsis vertical" />} icon={null} direction="left">
          <ActionsDropdownMenu>
            <Dropdown.Item
              icon="eye"
              text="Ver detalhes"
              onClick={() => onViewDetails(estate)}
            />
            {showBiometryAction && (
              <Dropdown.Item
                icon="share alternate"
                text="Compartilhar biometria"
                onClick={() => onShareBiometry(estate)}
              />
            )}
            {showRetryBiometryAction && onRetryBiometry && (
              <Dropdown.Item
                icon="redo"
                text="Reprocessar biometria"
                onClick={() => onRetryBiometry(estate)}
              />
            )}
            {showRegistrationAction && (
              <Dropdown.Item
                icon="edit"
                text="Gerenciar cadastro"
                onClick={() => onManageRegistration(estate)}
              />
            )}
            {showEditBankAccountAction && onEditBankAccount && (
              <Dropdown.Item
                icon="university"
                text="Alterar conta bancária"
                onClick={() => onEditBankAccount(estate)}
              />
            )}
            {showViewChargesAction && (
              <Dropdown.Item
                icon="list"
                text="Ver cobranças"
                onClick={() => onViewCharges(estate)}
              />
            )}
          </ActionsDropdownMenu>
        </Dropdown>
      </Menu.Item>
    </Menu>
  );
};

export default EstatesChargesActionsMenu;
